export default class BcpChangeYears extends HTMLSelectElement {
    constructor() {
        super();
    }

    connectedCallback() {
        setTimeout(() => {
            this.events();
            this.syncDatatableWithValue();
        }, 500);
    }

    events() {
        this.addEventListener('change',(e) => {
            this.loadKpiData();
        });
    }

    updateYearInUrl(url, newYear) {
        const pattern = /(All|\d+)\/salesman(\/\d{4})?$/;
        const currentYear = new Date().getFullYear();

        if (pattern.test(url)) {
            if (parseInt(newYear) === currentYear) {
                return url.replace(/\/\d{4}$/, '');
            }

            if (/\/\d{4}$/.test(url)) {
                return url.replace(/\/\d{4}$/, `/${newYear}`);
            }

            return `${url}/${newYear}`;
        }

        return url;
    }

    syncDatatableWithValue() {
        var year = this.value;

        $('[name="bcp_promotions___start_at_from"]').val('01/01/'+year);
        $('[name="bcp_promotions___start_at_to"]').val('31/12/'+year).trigger('change');

        window.history.pushState(null, '', this.updateYearInUrl(window.location.pathname, year));
        this.closest('.bpcSelectors').querySelectorAll('ul#salesmensDropdown li a').forEach(link => {
            const currentHref = link.getAttribute('href');
            const newHref = this.updateYearInUrl(currentHref, year);

            link.setAttribute('href', newHref);
        });
    }
    loadKpiData(){
        var _this = this;
        var year = _this.value;
        var salesman = null;
        var salesmanSelector = _this.closest('.bpcSelectors').querySelector('button#salesman');

        if (salesmanSelector) {
            salesman = salesmanSelector.dataset.salesman;
        }

        $.ajax({
            url: this.dataset.reload,
            method: 'POST',
            data: {year:year, salesman: salesman},
            success: function (data) {
                if(data){
                    var kpiBlock = $('#kpi-block');

                    kpiBlock.empty().html(data);
                }

                _this.syncDatatableWithValue();
            },
            error: function (data) {
                toastr.error('Une erreur s\'est produite au chargement de la page');
            }
        });
    }
}
